import { LogLevel } from '../enums/log-levels';

export class Log {
  Exception: string;
  Message: string;
  LogLevel: LogLevel;
}
